import { Environment } from 'commons/env';
import { appEnv } from 'config';
import React from 'react';

const { REACT_APP_VERSION, REACT_APP_GIT_BRANCH, REACT_APP_GIT_HASH } = import.meta.env;

interface Props {
  style?: React.CSSProperties;
}

export const VersionIndicator = (props: Props) => {
  if (appEnv === Environment.Local) {
    return <div style={props.style || {}}>dev</div>;
  }

  return (
    <div style={props.style || {}}>
      <b>
        {appEnv} {REACT_APP_VERSION}
      </b>{' '}
      <em>
        {REACT_APP_GIT_BRANCH}/{REACT_APP_GIT_HASH}
      </em>
    </div>
  );
};
